module.exports = __webpack_public_path__ + "static/img/about-advantage-1.7e79f59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/pc/about/about-advantage-1.png
// module id = 142
// module chunks = 0